const headerProviderMap = new Map<string, () => string>();

export const getHeaders = () =>
  Array.from(headerProviderMap.entries()).reduce(
    (acc, [key, provider]) => ({ ...acc, [key]: provider() }),
    {}
  );

export function registerHeaderProvider(key: string, provider: () => string): void {
  headerProviderMap.set(key, provider);
}

export const clearHeaderProviders = () => {
  headerProviderMap.clear();
};
